import React, { Component } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button, Form } from "semantic-ui-react";
import DatePicker from "react-datepicker";

class BankInfo extends Component {
  state = {};

  onSigEnd = (e, d) => {
    this.props.setAchSignature(this.sigCanvas.toDataURL());
  };

  onSigClear = (e) => {
    e.preventDefault();

    this.sigCanvas.clear();

    this.props.setAchSignature(null);
  };

  render() {
    let minDate = new Date();
    let maxDate = new Date().setDate(minDate.getDate() + 45);
    maxDate = new Date(maxDate);

    return (
      <div
        style={{
          padding: "25px 0",
          borderBottom: "1px solid #eee",
        }}
        data-private
      >
        <h2>Banking Information</h2>
        <Form size="large">
          <Form.Input
            name="bankName"
            required
            onChange={this.props.onChange}
            label="Bank Name"
            value={this.props.bankName}
          />
          <Form.Input
            name="bankRoutingNumber"
            required
            onChange={(e) =>
              !isNaN(e.target.value) && e.target.value.length <= 9
                ? this.props.onChange(e)
                : null
            }
            label="Bank Routing Number (9 digits)"
            value={this.props.routingNumber}
          />
          <Form.Field style={{ marginBottom: "25px" }}>
            <label>Type of Bank Account</label>
            <Form.Group>
              <Form.Radio
                label="Checking Account"
                checked={this.props.isChecking}
                name="isChecking"
                onChange={(e) =>
                  this.props.onChange({
                    target: { name: "isChecking", value: true },
                  })
                }
              />
              <Form.Radio
                label="Savings Account"
                checked={!this.props.isChecking}
                name="isChecking"
                onChange={(e) =>
                  this.props.onChange({
                    target: { name: "isChecking", value: false },
                  })
                }
              />
            </Form.Group>
          </Form.Field>
          <Form.Input
            name="bankAccountNumber"
            required
            onChange={(e) =>
              !isNaN(e.target.value) ? this.props.onChange(e) : null
            }
            label="Bank Account Number"
            value={this.props.accountNumber}
          />
          <Form.Input
            name="bankAccountNumberConfirmed"
            required
            onChange={(e) =>
              !isNaN(e.target.value) ? this.props.onChange(e) : null
            }
            onPaste={(e) => e.preventDefault()}
            label="Bank Account Number Confirmation"
            value={this.props.accountNumberConfirmed}
          />
          {/* <Form.Field className="required">
            <label>Payment Start Date (in the next 45 days)</label>
            <DatePicker
              dateFormat="MMMM d, yyyy"
              onChange={(e) => {
                this.props.onChange({
                  target: { name: "bankStartDate", value: e },
                });
              }}
              onChangeRaw={(e) => e.preventDefault()}
              placeholderText="Select a date..."
              minDate={minDate}
              maxDate={maxDate}
              selected={this.props.startDate}
            />
          </Form.Field> */}
          <Form.Select
            label="Select Payment Due Date"
            onChange={(e, d) =>
              this.props.onChange({
                target: { name: "bankStartDate", value: d.value },
              })
            }
            required
            value={this.props.startDate}
            placeholder="Select one..."
            options={[
              { key: 1, text: "1st", value: 1 },
              { key: 2, text: "2nd", value: 2 },
              { key: 3, text: "3rd", value: 3 },
              { key: 4, text: "4th", value: 4 },
              { key: 5, text: "5th", value: 5 },
              { key: 6, text: "6th", value: 6 },
              { key: 7, text: "7th", value: 7 },
              { key: 8, text: "8th", value: 8 },
              { key: 9, text: "9th", value: 9 },
              { key: 10, text: "10th", value: 10 },
              { key: 11, text: "11th", value: 11 },
              { key: 12, text: "12th", value: 12 },
              { key: 13, text: "13th", value: 13 },
              { key: 14, text: "14th", value: 14 },
              { key: 15, text: "15th", value: 15 },
              { key: 16, text: "16th", value: 16 },
              { key: 17, text: "17th", value: 17 },
              { key: 18, text: "18th", value: 18 },
              { key: 19, text: "19th", value: 19 },
              { key: 20, text: "20th", value: 20 },
              { key: 21, text: "21st", value: 21 },
              { key: 22, text: "22nd", value: 22 },
              { key: 23, text: "23rd", value: 23 },
              { key: 24, text: "24th", value: 24 },
              { key: 25, text: "25th", value: 25 },
              { key: 26, text: "26th", value: 26 },
              { key: 27, text: "27th", value: 27 },
              { key: 28, text: "28th", value: 28 },
            ]}
          />
          <div
            style={{
              padding: "0 0 20px 0",
            }}
          >
            <h2>Recurring Payment Authorization</h2>
            <Form>
              <Form.Checkbox
                label="I hereby authorize regularly scheduled charges to the above
                checking or savings account. I understand my account will be
                charged the Monthly Payment Amount above. I authorize adjustments
                to the Monthly Payment Amount for the purpose of sales tax when
                necessary. I understand and agree that the electronic debit will
                continue until the total amount due plus fees are collected, or
                until the Lessor revokes this authorization. This authorization is
                also applicable to new account information, payment amounts and
                payment dates provided by the renter at any time for the purpose
                of completing the account."
                checked={this.props.achAccepted}
                onChange={this.props.onAchAcceptChange}
              />
            </Form>
            {/* <p style={{
              fontSize: '1.25em',
              fontWeight: 'bold',
              color: 'red',
            }}>
              Sign Below
            </p>
            <SignatureCanvas
              canvasProps={{width: 500, height: 200}}
              ref={(ref) => { this.sigCanvas = ref}}
              onEnd={this.onSigEnd}
            />
            <p><b>{this.props.renter} - Renter</b></p>
            <Button
              negative
              content="Clear Signature"
              basic
              icon="eraser"
              labelPosition="right"
              onClick={this.onSigClear}
            /> */}
          </div>
        </Form>
      </div>
    );
  }
}

export default BankInfo;
